import styles from "components/modal/search/StoreSearchFilterModal.module.scss"
import Modal from "components/Modal";
import classNames from "classnames";
import {forwardRef, useEffect, useMemo, useRef, useState} from "react";
import SearchQueryTextBox from "components/textbox/SearchQueryTextBox";
import {CheckBox} from "components/CheckBox";
import {BrandNameCategoryIndex} from "components/layout/brands/BrandNameCategoryIndex";
import {
    getFirstCharacterIndex,
    getLocalStorageCountryCode,
    getOffsetTop,
    getPixelValueFromString,
    numberWithComma
} from "common/utils";
import ReloadIcon from "images/icons/reload.svg";
import FullButton from "components/buttons/FullButton";
import CloseIcon from "images/icons/close.svg";
import {Axios} from "api";
import {captureException, captureMessage} from "@sentry/nextjs";
import Loading from "components/Loading";
import LoadingDot from "components/LoadingDot";
import useTranslation from "next-translate/useTranslation";

export const STORE_SEARCH_FILTER_TYPE_CATEGORY = 'category'
export const STORE_SEARCH_FILTER_TYPE_BRAND = 'brand'
export const STORE_SEARCH_FILTER_TYPE_NONE = 'none'

const defaultScrollHistory = {
    finalScroll: 0,
}

const StoreSearchFilterModalCategoryContent = (props) => {
    const {categoryRelationList, currentFilterIdList, handleCategoriesSelect} = props;

    const handleSelect = (tag) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'StoreSearchFilterModalCategoryContentSelect',
            {
                tagId: tag.id,
                tagName: tag.name,
            }
        );
        handleCategoriesSelect([tag]);
    };

    const handleSelectAll = (categoryRelation) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('StoreSearchFilterModalCategoryContentSelectAll', {
            parentName: categoryRelation.parent_tag.name,
        });
        handleCategoriesSelect(categoryRelation.child_tags.map(x => x.tag));
    };

    console.log('categoryRelationList', categoryRelationList);

    return (
        <div className={styles.categoryContentContainer}>
            {
                categoryRelationList.map((relation) => {
                    return (
                        <div className={styles.categoryRow} key={`relation-parent-${relation.parent_tag.id}`}>
                            <div className={styles.parentTagContainer}>
                                <span className={styles.parentTag}>{relation.parent_tag.name}</span>
                                <span className={styles.selectAll} onClick={() => handleSelectAll(relation)}>전체선택</span>
                            </div>
                            <div className={styles.childTagContainer}>
                                {
                                    relation.child_tags.map(({tag, count}) => {
                                        return (
                                            <SearchQueryTextBox
                                                key={`relation-child-${tag.id}`}
                                                query={
                                                    <span>{tag.name}<span
                                                        className={styles.queryCount}>({count})</span></span>
                                                }
                                                onClick={() => handleSelect(tag)}
                                                isSelected={currentFilterIdList.includes(tag.id)}
                                            />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
};

const CategoryBrandList = forwardRef((props, ref) => {
    const {category, brands, currentFilterIdList, handleBrandsSelect} = props;
    const handleClick = (brand) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BrandListPageBrandClick', {brandId: brand.id});
        console.log('handleClick', brand);
        handleBrandsSelect(brand);
    };

    return (
        <div ref={ref} className={styles.brandCategoryListContainer}>
            {
                brands && brands.map(({brand, count}) =>
                    <div className={styles.brandRow} onClick={() => handleClick(brand)}>
                        <CheckBox
                            isChecked={currentFilterIdList.includes(brand.id)}
                            toggle={() => {
                            }}
                        />
                        <span className={styles.brandName}>{brand.name}<span className={styles.queryCount}>({count})</span></span>
                    </div>
                )
            }
        </div>
    )
});


const StoreSearchFilterModalBrandContent = (props) => {
    const [brandNameCategoryMap, setBrandNameCategoryMap] = useState({});
    const {brandFilterList, currentFilterIdList} = props;
    const [currentCategory, setCurrentCategory] = useState(null);
    const categoryListRefs = useRef({});
    const categorySelectorRef = useRef(null);
    const categoryList = ['ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ', '#',];

    useEffect(() => {
        const brandCategoryMap = {};
        const brandFilters = [...brandFilterList];
        brandFilters.sort((a, b) => a.brand.name.localeCompare(b.brand.name));
        brandFilters.map(x => {
            const index = getFirstCharacterIndex(x.brand.name);
            if (brandCategoryMap[index] === undefined) {
                brandCategoryMap[index] = [x];
            } else {
                brandCategoryMap[index].push(x);
            }
        });
        console.log('brandFilters', brandFilters);
        setBrandNameCategoryMap(brandCategoryMap);
    }, [brandFilterList]);


    const scrollInfo = useRef(defaultScrollHistory);
    const handleScroll = () => {
        const category = getCurrentCategory();
        setCurrentCategory(category);
        scrollInfo.current.finalScroll = window.scrollY;
    };

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track('ViewBrandList');

        // window.addEventListener('scroll', handleScroll, true);
        // return () => {
        //     window.removeEventListener('scroll', handleScroll, true);
        // }
    }, []);


    const categorySelectorTop = getPixelValueFromString(styles.categorySelectorTop);
    const brandListPadding = getPixelValueFromString(styles.brandListPadding);
    const categoryReverseList = ['ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ',].reverse();

    const categoryOffsetTop = e => {
        const scrollMargin = categorySelectorRef.current
            ? categorySelectorTop + brandListPadding + categorySelectorRef.current.offsetHeight
            : categorySelectorTop + brandListPadding;

        return getOffsetTop(e) - scrollMargin - 1;
    };

    const isScrollBelowElement = e => {
        // +1 at the end is a safe buffer since scrollY sometimes gives float value
        const scrollMargin = categorySelectorRef.current
            ? categorySelectorTop + brandListPadding + categorySelectorRef.current.offsetHeight
            : categorySelectorTop + brandListPadding;
        // console.log('scrollMargin', scrollMargin);
        return getOffsetTop(e) <= Math.round(window.scrollY + scrollMargin + 1);
    };

    const getCurrentCategory = () => {
        // console.log('window.scrollY' , window.scrollY);
        for (const idx in categoryReverseList) {
            const category = categoryReverseList[idx];
            // console.log('category', category);
            const ref = categoryListRefs.current[category];
            if (ref && isScrollBelowElement(ref)) {
                return category;
            }
        }
        return null;
    };

    const onCategoryClick = (x) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('StoreSearchFilterModalBrandContentBrandCategoryClick', {category: x});
        console.log('x', currentCategory);
        setCurrentCategory(prev => prev === x ? null : x);
        // if (categoryListRefs.current && categoryListRefs.current[x]) {
        //     window.scrollTo({
        //         top: categoryOffsetTop(categoryListRefs.current[x]),
        //         // behavior: 'smooth',
        //     });
        //     setCurrentCategory(prev => prev === x ? null : x);
        // }
    };

    const handleBrandsSelect = (brand) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'StoreSearchFilterModalBrandContentBrandSelect', {brandId: brand.id, brandName: brand.name}
        );
        props.handleBrandsSelect([brand]);
    };

    const handleSelectAll = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('StoreSearchFilterModalBrandContentSelectAll');
        props.handleBrandsSelect(brandFilterList.map(x => x.brand));
    }
    const countryCode = getLocalStorageCountryCode() ?? 'KR';

    return (
        <div className={styles.brandContentContainer}>
            {
                countryCode === 'KR' && (
                    <div className={styles.brandContentTitleContainer}>
                    <div className={styles.brandContentTitle}>
                        <span className={styles.parentTag}>브랜드</span>
                        <span className={styles.selectAll} onClick={handleSelectAll}>전체선택</span>
                    </div>
                    <BrandNameCategoryIndex
                        currentCategoryKey={currentCategory}
                        setCurrentCategoryKey={onCategoryClick}
                    />
                </div>
            )
            }
            <div className={styles.brandRowContainer}>
                {
                    categoryList.filter(
                        x => (currentCategory === null || x === currentCategory) && brandNameCategoryMap[x] && categoryListRefs.current
                    ).map(x =>
                        <CategoryBrandList
                            key={`brand_list_${x}`}
                            ref={el => categoryListRefs.current[x] = el}
                            category={x}
                            brands={brandNameCategoryMap[x]}
                            currentFilterIdList={currentFilterIdList}
                            handleBrandsSelect={handleBrandsSelect}
                        />
                    )
                }
            </div>
        </div>
    )
};

export const StoreSearchFilterModal = (props) => {
    const {filterInfo, idToCategoryFilter, idToBrandFilter, modalMode, queryFilterInfo, fetchFilters} = props;

    const {t} = useTranslation('sections-search-store-StoreSearchFilter');

    const [activeTab, setActiveTab] = useState(modalMode);
    const [currentFilterInfo, setCurrentFilterInfo] = useState(props.currentFilterInfo);

    const [isLoading, setIsLoading] = useState(false);

    const handleCategoryClick = (category) => {
        setActiveTab(category);
    };

    useEffect(() => {
        setActiveTab(modalMode);
    }, [modalMode]);

    const updateFilterInfo = async () => {
        const {query, isNameOnly, isSpecialPriceOnly} = queryFilterInfo;
        try {
            setIsLoading(true);

            const categoryIds = currentFilterInfo.categoryIds;
            const brandIds = currentFilterInfo.brandIds;

            await fetchFilters(
                query, isNameOnly, isSpecialPriceOnly, categoryIds, brandIds,
            );
        } catch (e) {
            console.log('fetchProducts error', e);
            captureException(e);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        updateFilterInfo();
    }, [currentFilterInfo]);

    const currentFilterInfos = useMemo(() => {
        if (!Boolean(currentFilterInfo) || !Boolean(idToCategoryFilter) || !Boolean(idToBrandFilter)) {
            return [];
        }
        const filterNames = [];
        let totalCount = 0;
        console.log('currentFilterInfo', currentFilterInfo);
        currentFilterInfo.categoryIds.forEach(idx => {
            if (idx in idToCategoryFilter) {
                filterNames.push({
                    id: idx,
                    name: idToCategoryFilter[idx].tag.name,
                    type: 'category',
                });
                totalCount += idToCategoryFilter[idx].count;
            }
        });
        currentFilterInfo.brandIds.forEach(idx => {
            if (idx in idToBrandFilter) {
                filterNames.push({
                    id: idx,
                    name: idToBrandFilter[idx].brand.name,
                    type: 'brand',
                });
                totalCount += idToBrandFilter[idx].count;
            }
        });
        return {
            filterNames,
            totalCount,
        };
    }, [currentFilterInfo, idToCategoryFilter, idToBrandFilter]);

    const handleSubmit = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('StoreSearchFilterModalSubmit');
        props.handleSubmit(currentFilterInfo);
    };

    const handleCategoriesSelect = (categoryList) => {
        setCurrentFilterInfo(prevFilterInfo => {
            const categoryIds = [...prevFilterInfo.categoryIds];
            // if every category is already included, delete them all
            const targetCategoryIds = categoryList.map(c => c.id);
            if (targetCategoryIds.every(x => categoryIds.includes(x))) {
                return {
                    ...prevFilterInfo,
                    categoryIds: categoryIds.filter(x => !targetCategoryIds.includes(x)),
                };
            }
            const finalCategoryIds = new Set([...categoryIds, ...targetCategoryIds])
            return {
                ...prevFilterInfo,
                categoryIds: Array.from(finalCategoryIds),
            };
        });
    };

    const handleBrandsSelect = (brandList) => {
        setCurrentFilterInfo(prevFilterInfo => {
            const brandIds = [...prevFilterInfo.brandIds];
            const targetBrandIds = brandList.map(c => c.id);
            if (targetBrandIds.every(x => brandIds.includes(x))) {
                return {
                    ...prevFilterInfo,
                    brandIds: brandIds.filter(x => !targetBrandIds.includes(x)),
                };
            }
            const finalBrandIds = new Set([...brandIds, ...targetBrandIds])
            return {
                ...prevFilterInfo,
                brandIds: Array.from(finalBrandIds),
            };
        })
    };

    const handleReset = () => {
        setCurrentFilterInfo({
            categoryIds: [],
            brandIds: [],
        })
    };

    const handleDeleteFilter = (info) => {
        if (info.type === 'category') {
            handleCategoriesSelect([info]);
        } else if (info.type === 'brand') {
            handleBrandsSelect([info]);
        }
    };

    const handleClose = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('StoreSearchFilterModalClose');
        setCurrentFilterInfo(props.currentFilterInfo);
        props.handleClose();
    };

    return (
        <Modal bottom isOpen={modalMode !== STORE_SEARCH_FILTER_TYPE_NONE} close={handleClose} height={'80%'} width={'100%'}>
            <div className={styles.container}>
                <div className={styles.filterTypeSection}>
                    <span
                        className={classNames(styles.filterCategory, activeTab === STORE_SEARCH_FILTER_TYPE_CATEGORY && styles.activeCategory)}
                        onClick={() => handleCategoryClick(STORE_SEARCH_FILTER_TYPE_CATEGORY)}
                    >
                        {t('FilterText.category')}{currentFilterInfo && currentFilterInfo.categoryIds.length > 0 ? `(${numberWithComma(currentFilterInfo.categoryIds.length)})` : ''}
                    </span>
                    <span
                        className={classNames(styles.filterCategory, activeTab === STORE_SEARCH_FILTER_TYPE_BRAND && styles.activeCategory)}
                        onClick={() => handleCategoryClick(STORE_SEARCH_FILTER_TYPE_BRAND)}
                    >
                        {t('FilterText.brand')}{currentFilterInfo && currentFilterInfo.brandIds.length > 0 ? `(${numberWithComma(currentFilterInfo.brandIds.length)})` : ''}
                    </span>
                </div>
                {
                    activeTab === STORE_SEARCH_FILTER_TYPE_CATEGORY ?
                        <StoreSearchFilterModalCategoryContent
                            categoryRelationList={filterInfo.tag_relations}
                            currentFilterIdList={currentFilterInfo.categoryIds}
                            handleCategoriesSelect={handleCategoriesSelect}
                        /> :
                        <StoreSearchFilterModalBrandContent
                            brandFilterList={filterInfo.brands}
                            currentFilterIdList={currentFilterInfo.brandIds}
                            handleBrandsSelect={handleBrandsSelect}
                        />
                }
                <div className={styles.bottomContainer}>
                    {
                        currentFilterInfos && currentFilterInfos.filterNames.length > 0 &&
                        <div className={styles.activeFilterContainer}>
                            {
                                currentFilterInfos.filterNames.map(info => {
                                    return <SearchQueryTextBox
                                        key={`filter-category-${info.name}-${info.type}`}
                                        query={
                                            <span className={styles.currentQueryBox}>
                                                <span>{info.name}</span>
                                                <CloseIcon
                                                    className={styles.closeIcon}
                                                    width="17"
                                                    height="17"
                                                    viewBox="0 0 20 20"
                                                />
                                            </span>
                                        }
                                        isSelected
                                        onClick={() => {
                                            handleDeleteFilter(info)
                                        }}
                                    />
                                })
                            }
                        </div>
                    }
                    <div className={styles.operatorContainer}>
                        <div className={styles.resetContainer} onClick={handleReset}>
                            <ReloadIcon className={styles.reloadIcon}/>
                            <span className={styles.resetText}>{t('StoreSearchFilterModal.reset')}</span>
                        </div>
                        <div className={styles.buttonContainer}>
                            <FullButton
                                title={
                                    isLoading ?
                                        <LoadingDot white style={{height: 48}}/> :
                                        filterInfo.total_count ?
                                            t('StoreSearchFilterModal.viewProducts', {count: filterInfo.total_count}) :
                                            t('StoreSearchFilterModal.viewAllProducts')
                                }
                                height={48} fontSize={16}
                                onClick={handleSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
};
